import React, { useState } from 'react'
import { Stack } from '@mui/material'

import Header from './Header'
import Body from './Body/Body'

const Traffic: React.FC = () => {
  const [isEvolutionMode, setIsEvolutionMode] = useState(false)

  return (
    <Stack gap={2}>
      <Header loading={false} isEvolutionMode={isEvolutionMode} />
      <Body onViewTypeChange={setIsEvolutionMode} />
    </Stack>
  )
}

export default Traffic
